/**
 * - set **window.passJSON** with the given `passUserData`
 * - call **window.waitForPassJSON**
 */
export const setPassJSON = (passUserData: typeof window.passJSON): void => {
  window.passJSON = passUserData;
  window.waitForPassJSON?.();
};
